import React, { useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Home.css";
import FAQAccordion from "../components/FAQAccordion";
import PartnerCards from "../components/PartnerCards";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useNavigate } from "react-router-dom";

function LandingPage() {
    const partnerRef = useRef();
    const navigate = useNavigate();

    const scrollToComponent = () => {
        window.location.href = "https://app.psicopatici.com/";
    };

    const scrollToTOTEM = () => {
        navigate("/totemtouch")
    };

    // Modifica l'oggetto heroStyle con questi valori
    const heroStyle = {
        backgroundImage: `linear-gradient(to bottom, 
        rgba(0, 0, 0, 0.7) 0%,    /* Top: ora è più deciso */
        rgba(0, 0, 0, 0.35) 45%,  /* Centro: più scuro di prima (era 0.1), ma i testi restano leggibili */
        rgba(0, 0, 0, 0.8) 75%,   /* Transizione: inizia a scendere nel nero più velocemente */
        rgba(0, 0, 0, 1) 98%      /* Fondo: Nero assoluto per fusione perfetta */
    ), 
    url('/img/homepage/Homepage.jpeg')`
    };

    return (
        <>
            <div className="bg-black d-flex flex-column align-items-center">
                <div className="w-100" style={{ marginTop: "69px" }}>

                    {/* --- HERO --- */}
                    <section className="hero-section-custom text-center" style={heroStyle}>
                        <Container>
                            <h1 className="hero-title-main mb-4">Diventa Partner Psicopatici Italia</h1>
                            <div>
                                <p style={{ fontSize: "30px" }} className="hero-subtitle-custom mb-3 mb-md-5 text-white fw-bolder">
                                    Sei un Content Creator?
                                </p>
                                <p className="text-white mb-4 paragraph-hero px-2">
                                    Trasforma i tuoi contenuti in guadagni reali con Psicopatici Italia.<br className="d-none d-md-block" />
                                    Crei contenuti, condividi il brand, guadagni su vendite, iscrizioni ed engagement dei tuoi contenuti.<br className="d-none d-md-block" />
                                    Candidati come Partner e ricevi subito <strong style={{ fontSize: '22px' }}>25€ di BONUS BENVENUTO.</strong>
                                </p>
                                <div className="mb-4 mb-md-5">
                                    <button
                                        className="hero-btn-main bg-white text-dark fw-bold"
                                        onClick={scrollToComponent}
                                    >
                                        Diventa Partner
                                    </button>
                                    <p style={{ fontSize: '10px' }} className="text-white mt-2 opacity-75">Richiede meno di 2 minuti</p>
                                </div>
                            </div>
                        </Container>
                    </section>

                    {/* --- SFONDO NERO SOLO PER "COSA PUOI FARE" --- */}
                    <div className="bg-black d-flex flex-column align-items-center text-white px-3">
                        <div style={{ maxWidth: "1400px", width: "100%" }}>
                            {/* --- COSA PUOI FARE --- */}
                            {/* py-4 su mobile, py-5 su desktop */}
                            <section className="pt-md-0 pb-md-0">
                                <div>
                                    <h2 className="fw-bold text-center mb-4 subTitle text-white hero-title-main">Cosa puoi fare come Partner</h2>
                                    <p className="text-white mb-4 mb-md-5 section-description-partner text-center paragraph-hero px-2">
                                        Come Partner puoi scegliere liberamente una o più attività, senza alcun obbligo.<br className="d-none d-md-block" />
                                        Sei tu a decidere quanto essere attivo e come partecipare al progetto.<br className="d-none d-md-block" />
                                        Ogni attività viene tracciata tramite link personale e strumenti dedicati.
                                    </p>

                                    <PartnerCards />
                                </div>
                            </section>
                        </div>
                    </div>

                    {/* --- SFONDO GRADIENTE PURPLE --- */}
                    <div className="purple-gradient-bg d-flex flex-column align-items-center text-white px-3">
                        <div style={{ maxWidth: "1400px", width: "100%" }}>

                            <hr className="my-4 my-md-5 border-secondary opacity-25" />

                            {/* --- VALUE PROP / CREATE SHARE EARN --- */}
                            <section className="pt-4 pb-0 pt-md-5 pb-md-0 text-center">
                                <h2 style={{ lineHeight: '1' }} className="fw-bolder mb-0 mb-md-0 subTitle hero-title-main">Trasforma la tua creatività <br className="d-none d-md-block" /> in valore reale</h2>

                                <div className="visual-gif-container text-center mb-2 mb-md-0">
                                    <img
                                        src="/img/homepage/creteShare.gif"
                                        alt="Create Share Earn"
                                        className="gif-responsive"
                                    />
                                </div>

                                {/* Testi descrittivi */}
                                <div className="mb-4 mb-md-5 px-2">
                                    <p className="mb-1 paragraph-hero">Non servono competenze avanzate</p>
                                    <p className="mb-1 paragraph-hero">Ti forniamo strumenti e risorse semplici per iniziare subito a guadagnare.</p>
                                    <p className="mb-1 paragraph-hero">Se lo desideri, puoi anche sponsorizzare i tuoi contenuti, ma non è richiesto.</p>
                                    <p className="mb-5 paragraph-hero">Ogni attività viene tracciata tramite link personale e strumenti dedicati.</p>
                                </div>

                                {/* Blocchi descrittivi con stile Glow Card (SWIPER) */}
                                {/* Aggiunto py-4 per dare spazio sopra/sotto al bagliore tagliato */}
                                <div className="mt-4 mt-md-5 px-2 py-4 custom-swiper-container">
                                    <Swiper
                                        modules={[Autoplay, Pagination]}
                                        pagination={{
                                            clickable: true,
                                            bulletClass: "swiper-pagination-bullet bg-secondary",
                                            bulletActiveClass: "swiper-pagination-bullet-active bg-white",
                                        }}
                                        autoplay={{
                                            delay: 5000,
                                            disableOnInteraction: false,
                                        }}
                                        spaceBetween={30}
                                        slidesPerView={1}
                                        breakpoints={{
                                            768: { slidesPerView: 2, spaceBetween: 20 },
                                            1024: { slidesPerView: 3, spaceBetween: 30 },
                                        }}
                                        className="pb-5"
                                    >
                                        <SwiperSlide className="d-flex h-auto">
                                            <div className="glow-card-wrapper w-100 mx-auto" style={{ maxWidth: "400px", zIndex: 2 }}>
                                                <div className="glow-card-content-transparent d-flex flex-column h-100 text-center px-3 py-4">
                                                    <h5 className="card-title-extra mb-3">
                                                        CREI CONTENUTI CON IL TUO STILE
                                                    </h5>
                                                    <p className="card-text-desc mb-0">
                                                        Usando prodotti, foto, video, render e materiali ufficiali del brand pronti da utilizzare oppure contenuti creati da te.
                                                    </p>
                                                </div>
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide className="d-flex h-auto">
                                            <div className="glow-card-wrapper w-100 mx-auto" style={{ maxWidth: "400px", zIndex: 2 }}>
                                                <div className="glow-card-content-transparent d-flex flex-column h-100 text-center px-3 py-4">
                                                    <h5 className="card-title-extra mb-3">
                                                        CONDIVIDI CON IL TUO PUBBLICO
                                                    </h5>
                                                    <p className="card-text-desc mb-0">
                                                        Pubblica i contenuti sui tuoi canali (Instagram, TikTok, YouTube o blog). Puoi raccontare prodotti, outfit, concept o semplicemente il tuo punto di vista sul brand.
                                                    </p>
                                                </div>
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide className="d-flex h-auto">
                                            <div className="glow-card-wrapper w-100 mx-auto" style={{ maxWidth: "400px", zIndex: 2 }}>
                                                <div className="glow-card-content-transparent d-flex flex-column h-100 text-center px-3 py-4">
                                                    <h5 className="card-title-extra mb-3">
                                                        GUADAGNI AUTOMATICAMENTE
                                                    </h5>
                                                    <p className="card-text-desc mb-0">
                                                        Ogni contenuto è collegato al tuo link partner personale, così tutte le interazioni, iscrizioni e vendite generate vengono automaticamente tracciate.
                                                    </p>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    </Swiper>
                                </div>
                            </section>


                            {/* --- NUOVA SEZIONE: STORE O SPAZIO FISICO --- */}
                            <section className="pb-5 pt-5 py-md-5">
                                <Container>
                                    <h1 className="fw-bolder mb-0 hero-title-main" style={{ lineHeight: '1' }}>
                                        HAI UNO STORE O UNO SPAZIO FISICO?
                                    </h1>

                                    {/* mt-1 mette solo un piccolissimo distacco, fw-bold e il colore blu/ciano per risaltare */}
                                    <p className="mt-1 sub-store" style={{ fontSize: '29.2px', letterSpacing: '1px' }}>
                                        SENZA GESTIONE DI MAGAZZINO E CON COMMISSIONI SULLE VENDITE GENERATE
                                    </p>

                                    {/* Resto della descrizione standard sotto */}
                                    <p className="text-center mb-5 section-description-partner paragraph-hero mx-auto px-2 mt-5" style={{ maxWidth: "800px" }}>
                                        Puoi diventare Partner Totem Psicopatici e offrire ai tuoi clienti un'esperienza di acquisto innovativa direttamente nel tuo negozio. Un'innovazione tecnologica che si integra perfettamente nel tuo Negozio.
                                    </p>

                                    <Row className="justify-content-center align-items-center g-4 mt-2">
                                        <Col xs={12} lg={6} className="text-start order-2 order-lg-1 px-4 px-lg-3">
                                            <h4 style={{ fontSize: '34px' }} className="mb-3 mb-md-4 text-center text-lg-start card-title-welcome">CON IL TOTEM TOUCH PSICOPATICI I CLIENTI POSSONO:</h4>
                                            <ul className="list-unstyled fs-5">
                                                <li className="mb-0 d-flex align-items-center">
                                                    <span style={{ color: '#d63384', marginRight: '15px', fontSize: '1.2em' }}>■</span> esplorare l'intera collezione Psicopatici
                                                </li>
                                                <li className="mb-0 d-flex align-items-center">
                                                    <span style={{ color: '#d63384', marginRight: '15px', fontSize: '1.2em' }}>■</span> personalizzare i capi
                                                </li>
                                                <li className="mb-0 d-flex align-items-center">
                                                    <span style={{ color: '#d63384', marginRight: '15px', fontSize: '1.2em' }}>■</span> acquistare direttamente in store
                                                </li>
                                            </ul>

                                            <div className="mt-5 text-center text-lg-end">
                                                <button
                                                    className="hero-btn-main bg-white text-dark fw-bold"
                                                    onClick={scrollToTOTEM}
                                                >
                                                    Scopri di più
                                                </button>

                                            </div>
                                        </Col>
                                        <Col xs={12} lg={6} className="order-1 order-lg-2">
                                            <div className="visual-gif-container text-center d-flex justify-content-center">
                                                <div className="glow-wrapper-rounded">
                                                    <img
                                                        src="/img/homepage/video_landing_partner_totem.gif"
                                                        alt="Totem In Store"
                                                        className="img-rounded-led img-fluid"
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                </Container>
                            </section>

                            {/* --- DASHBOARD / COME GUADAGNANO SECTION --- */}
                            <section className="py-5 py-md-5" ref={partnerRef}>
                                <div className="container px-2 px-md-3"> {/* Aggiunto padding container per mobile */}
                                    <h1 style={{ lineHeight: '1' }} className="hero-title-main mb-5 mb-md-5 pb-2">Come guadagnano i partner di <br className="d-none d-md-block" /> Psicopatici Italia</h1>

                                    <Row className="align-items-center justify-content-center g-4">
                                        {/* Aggiunto px-3 per evitare che la card tocchi i bordi laterali su mobile */}
                                        <Col xs={12} lg={6} className="text-center mb-4 mb-lg-0 d-flex justify-content-center px-3 px-md-2">
                                            <div className="glow-card-wrapper w-100" style={{ maxWidth: "350px", zIndex: 2 }}>
                                                <div className="glow-card-content d-flex flex-column justify-content-center align-items-center text-center py-4 py-md-5">
                                                    <h3 className="card-title-extra2">BONUS EXTRA</h3>
                                                    <p className="card-text-desc mt-3 mb-3 px-3">
                                                        OTTIENI <strong>€0,50</strong> PER OGNI NUOVA<br />
                                                        REGISTRAZIONE VALIDA GENERATA DAL<br />
                                                        TUO <strong>LINK</strong>.
                                                    </p>
                                                    <h4 style={{ fontSize: "26px" }} className="card-title-welcome mt-3">BONUS BENVENUTO</h4>
                                                    <div className="card-price my-2 my-md-3">€25</div>
                                                    <p className="card-text-desc mb-3">
                                                        ALLA REGISTRAZIONE COME<br />
                                                        <strong>PARTNER</strong>
                                                    </p>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} lg={6} className="ps-lg-5 earning-steps-container text-start px-4 px-lg-5">
                                            <div className="earning-item mb-4 mb-md-5">
                                                <h3 style={{ fontSize: "23px", lineHeight: "1", letterSpacing: "1px" }} className="earning-step-title mb-2 mt-0 card-title-welcome">Condividi il tuo link partner</h3>
                                                <p style={{ fontSize: "16px" }} className="earning-step-text mb-0">
                                                    Dopo l'iscrizione ricevi un link personale da condividere con la tua community, sui social o dove preferisci.
                                                </p>
                                            </div>
                                            <div className="earning-item mb-4 mb-md-5">
                                                <h3 style={{ fontSize: "23px", lineHeight: "1", letterSpacing: "1px" }} className="earning-step-title mb-2 card-title-welcome">Porta nuovi utenti e nuovi clienti +0,50€</h3>
                                                <p style={{ fontSize: "16px" }} className="earning-step-text mb-0">
                                                    Le persone che si registrano tramite link entrano nella tua rete e generano valore nel tempo.
                                                </p>
                                            </div>
                                            <div className="earning-item">
                                                <h3 style={{ fontSize: "23px", lineHeight: "1", letterSpacing: "1px" }} className="earning-step-title mb-2 card-title-welcome">Guadagna commissioni automatiche</h3>
                                                <div className="earning-step-text">
                                                    <p style={{ fontSize: "16px" }} className="mb-3">Ricevi una commissione su ogni acquisto effettuato dagli utenti che arrivano tramite il tuo link partner.</p>
                                                    <ul className="list-unstyled mb-3 ps-2" style={{ borderLeft: "2px solid #d63384" }}>
                                                        <li style={{ fontSize: "16px" }} className="mb-2 ms-3">Dal 1° al 25° acquisto → <strong style={{ fontWeight: 'bold' }}>15%</strong></li>
                                                        <li style={{ fontSize: "16px" }} className="mb-2 ms-3">Dal 26° al 100° acquisto → <strong>18%</strong></li>
                                                        <li style={{ fontSize: "16px" }} className="mb-2 ms-3">Dal 101° al 250° acquisto → <strong>21%</strong></li>
                                                        <li style={{ fontSize: "16px" }} className="mb-0 ms-3">Dal 251° acquisto → <strong>24%</strong></li>
                                                    </ul>
                                                    <p style={{ fontSize: "16px" }} className="mb-3">Più vendite generi, più aumenta la tua precentuale.</p>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </section>

                        </div>
                    </div>
                </div>
            </div>

            {/* --- FAQ --- */}
            <section className="py-4 py-md-5 bg-white px-3">
                <Container className="my-2 my-md-4">
                    <h2 className="fw-bold text-center mb-4 mb-md-5 text-dark">Domande Frequenti</h2>
                    <FAQAccordion />
                </Container>
            </section>
        </>
    );
}

export default LandingPage;